import AutoCompleteMenu from '@trilogy-ds/react/lib/components/autocomplete/menu';
export default AutoCompleteMenu;
//# sourceMappingURL=index.js.map